var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedCheckboxGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 16.875H2.8125C1.88051 16.875 1.125 16.1195 1.125 15.1875V2.8125C1.125 1.88051 1.88051 1.125 2.8125 1.125H15.1875C16.1195 1.125 16.875 1.88051 16.875 2.8125V15.1875C16.875 16.1195 16.1195 16.875 15.1875 16.875ZM7.99151 13.4276L14.4603 6.95886C14.6799 6.73921 14.6799 6.38304 14.4603 6.16338L13.6648 5.3679C13.4451 5.14825 13.089 5.14821 12.8693 5.3679L7.59375 10.6434L5.13074 8.18037C4.91108 7.96071 4.55491 7.96071 4.33522 8.18037L3.53974 8.97585C3.32009 9.1955 3.32009 9.55167 3.53974 9.77133L7.19599 13.4276C7.41568 13.6473 7.77182 13.6473 7.99151 13.4276Z",
    fill: "#6FCC87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckboxGreen);
export default __webpack_public_path__ + "static/media/CheckedCheckboxGreen.3ee520d4739051d11a85f6f06a3ce343.svg";
export { ForwardRef as ReactComponent };